module.exports = __webpack_public_path__ + "images/Globe.a41ddab5d77bf2c74f43bbff864d855f.svg";